import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, CircleDot, ArrowLeftRight, SwatchBook, ArrowRightLeft, Contrast, Palette, Layers, BookOpen, FileText } from './icons';
import BrandLogo from './BrandLogo';

const NAV_LINKS = [
  { to: '/', label: 'Color wheel', icon: CircleDot },
  { to: '/compare', label: 'Compare', icon: ArrowLeftRight },
  { to: '/colors', label: 'Colors', icon: SwatchBook, paths: ['/color/', '/themes/', '/palette/', '/palette-library/', '/image-color-picker'] },
  { to: '/converter', label: 'Converter', icon: ArrowRightLeft },
  { to: '/contrast-checker', label: 'Contrast', icon: Contrast },
  { to: '/studio', label: 'Studio', icon: Palette },
  { to: '/brand-builder', label: 'Brand', icon: Layers },
  { to: '/theory', label: 'Theory', icon: BookOpen, paths: ['/models'] },
  { to: '/blog', label: 'Blog', icon: FileText },
];

export default function SharedHeader() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const toggle = useRef<HTMLButtonElement>(null);
  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    if (!open) return;
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { setOpen(false); toggle.current?.focus(); }
    };
    document.addEventListener('keydown', close);
    return () => document.removeEventListener('keydown', close);
  }, [open]);

  const links = (mobile = false) => NAV_LINKS.map(({ to, label, icon: Icon, paths }) => {
    const active = pathname === to || (to !== '/' && pathname.startsWith(to + '/')) || paths?.some(path => pathname.startsWith(path));
    return <Link key={to} to={to} onClick={() => setOpen(false)} aria-current={active ? 'page' : undefined} className="ui-nav-link">
      {mobile && <Icon size={18} aria-hidden="true" />}{label}
    </Link>;
  });

  return (
    <header className="sticky top-0 z-40 border-b border-surface-border bg-white/95 backdrop-blur-md">
      <div className="site-container flex min-h-16 items-center justify-between gap-4 py-2">
        <BrandLogo />
        <nav aria-label="Main navigation" className="hidden items-center gap-0.5 lg:flex">{links()}</nav>
        <button ref={toggle} className="ui-icon-button lg:hidden" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls="mobile-navigation" aria-label={open ? 'Close menu' : 'Open menu'}>
          {open ? <X size={20} aria-hidden="true" /> : <Menu size={20} aria-hidden="true" />}
        </button>
      </div>
      {open && <nav id="mobile-navigation" aria-label="Mobile navigation" className="site-container grid max-h-[calc(100dvh-4rem)] grid-cols-2 gap-1 overflow-y-auto border-t border-surface-border py-3 lg:hidden">{links(true)}</nav>}
    </header>
  );
}
